import React from 'react';
import { motion } from 'framer-motion';
import { CTAButton } from './CTAButton';
export function FinalCTA() {
  return <section className="py-24 px-4 bg-brand-bgAlt relative overflow-hidden" data-id="element-109">
      <div className="max-w-4xl mx-auto text-center relative z-10" data-id="element-110">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} data-id="element-111">
          <h2 className="text-4xl md:text-5xl lg:text-6xl font-bold text-brand-plum mb-8 leading-tight" data-id="element-112">
            <span className="block text-5xl mb-6" data-id="element-113">🌸</span>
            Mi Pequeña... La Vida Que Mereces Ya Existe. <br data-id="element-114" />
            <span className="text-brand-rose font-script text-5xl md:text-7xl mt-4 block" data-id="element-115">
              Solo Está Esperando Que La Reclames.
            </span>
          </h2>

          <div className="space-y-6 text-lg md:text-xl text-brand-textLight max-w-2xl mx-auto mb-12" data-id="element-116">
            <p data-id="element-117">
              Si llegaste hasta aquí, hay algo en ti que ya sabe que es el
              momento.
            </p>
            <p data-id="element-118">No el momento perfecto. Simplemente: el momento.</p>
            <p data-id="element-119">
              Hay una versión de ti que se despierta cada mañana sintiéndose
              plena. Que ve el dinero fluir con naturalidad. Que atrae amor,
              oportunidades y paz sin perseguirlos desesperadamente. Que sabe
              exactamente para qué está aquí.
            </p>
            <p className="font-bold text-brand-plum" data-id="element-120">
              Esa versión no es un sueño lejano.
            </p>
            <p data-id="element-121">Está a un solo paso de donde estás ahora.</p>
            <p data-id="element-122">
              Y la Abu ya recorrió el camino completo — para que tú no tengas
              que ir sola.
            </p>

            <div className="bg-white p-6 rounded-2xl border border-brand-gold/30 my-8" data-id="element-123">
              <p className="font-medium" data-id="element-124">
                Por solo{' '}
                <span className="font-bold text-brand-rose" data-id="element-125">$14 USD</span>{' '}
                tienes acceso a 35 años de sabiduría vivida, 7 materiales
                completos y el método que ya transformó la vida de miles de
                personas como tú.
              </p>
            </div>

            <p className="font-bold text-2xl text-brand-plum" data-id="element-126">
              No hay razón para esperar un día más.
            </p>
          </div>

          <div className="mb-12" data-id="element-127">
            <h3 className="text-3xl font-bold text-brand-rose mb-8" data-id="element-128">
              🔥 ¡TOMA LA DECISIÓN DE VIVIR TUS SUEÑOS HOY!
            </h3>
            <CTAButton text="¡SÍ, QUIERO MI TRANSFORMACIÓN AHORA — $14 USD!" data-id="element-129" />
          </div>

          <div className="mt-8 text-brand-textLight space-y-2 font-medium" data-id="element-130">
            <p data-id="element-131">
              Acceso inmediato • 7 materiales en tu correo • Garantía de 7 días
            </p>
            <p className="flex items-center justify-center gap-2" data-id="element-132">
              <span className="text-brand-gold" data-id="element-133">🔒</span> Pago único y seguro a
              través de Hotmart • Sin suscripciones ocultas
            </p>
          </div>

          <div className="mt-16 pt-12 border-t border-brand-rose/20" data-id="element-134">
            <p className="font-serif text-2xl md:text-3xl text-brand-plum italic mb-8" data-id="element-135">
              "El único paso que separa tu vida actual de la vida que ya
              mereces... es este."
            </p>
            <p className="text-xl text-brand-textLight mb-2" data-id="element-136">
              Con todo mi amor y mis mejores deseos para ti,
            </p>
            <p className="font-script text-5xl text-brand-rose mb-6" data-id="element-137">
              🌸 La Abu Aurora
            </p>
            <p className="font-script text-2xl text-brand-plum" data-id="element-138">
              "No es casualidad que hayas llegado hasta aquí. Nunca lo es, mi
              pequeña."
            </p>
          </div>
        </motion.div>
      </div>

      <div className="absolute top-0 left-0 w-full h-full bg-[url('data:image/svg+xml,%3Csvg viewBox=%220 0 200 200%22 xmlns=%22http://www.w3.org/2000/svg%22%3E%3Cfilter id=%22noiseFilter%22%3E%3CfeTurbulence type=%22fractalNoise%22 baseFrequency=%220.65%22 numOctaves=%223%22 stitchTiles=%22stitch%22/%3E%3C/filter%3E%3Crect width=%22100%25%22 height=%22100%25%22 filter=%22url(%23noiseFilter)%22 opacity=%220.05%22/%3E%3C/svg%3E')] opacity-40 mix-blend-overlay pointer-events-none" data-id="element-139"></div>
    </section>;
}